import { FC } from "react";

import { IPickerListItem, Picker } from "@livechat/design-system-react-components";

import { Filter } from "constants/filters";
import { IAgent } from "store/entities/agents";

import { IFilterUpdate } from "../interfaces";
import { withFilterBase } from "../withFilterBase";

import { createAgentOption } from "./agent-filter";

interface IProps {
  filterValues: string[];
  agents: IAgent[];
  currentAgent: IAgent;
  onChange(filterUpdate: IFilterUpdate<string[] | string>): void;
  multiple?: boolean;
}

const AgentFilter: FC<IProps> = ({ agents, currentAgent, onChange, filterValues, multiple }) => {
  const handleChange = (selectedItem: IPickerListItem[] | null): void => {
    onChange({
      name: Filter.Author,
      value: multiple ? (selectedItem?.map(item => item.key) ?? []) : (selectedItem?.[0].key ?? ""),
    });
  };

  const selectedAgents = agents
    .filter(agent => filterValues?.includes(agent.id))
    .map(agent => ({ key: agent.id, name: agent.name }));

  return (
    <Picker
      id="author-filter"
      openedOnInit
      placeholder="Select"
      isVisible
      type={multiple ? "multi" : "single"}
      options={agents.map(agent => createAgentOption(agent, currentAgent))}
      selected={selectedAgents}
      onSelect={handleChange}
      hideClearButton
    />
  );
};

export default withFilterBase(AgentFilter);
